export const CLASSPREFIX = 'muze';

export const CONTINOUS = 'continous';
export const DISCRETE = 'discrete';
export const SEQUENTIAL = 'sequential';
export const ORDINAL = 'ordinal';
export const LINEAR = 'linear';
export const BAND = 'band';
export const THRESHOLD = 'threshold';
export const QUANTIZE = 'quantize';
export const QUANTILE = 'quantile';

export const COLOR = 'color';
export const SHAPE = 'shape';
export const SIZE = 'size';

export const DOMAIN = 'domain';
export const HIDDEN = 'hidden';
export const NUMBER = 'number';
export const BOTTOM = 'bottom';
export const TOP = 'top';

export const RGB = 'rgb';
export const HEX = 'hex';
export const HSLA = 'hsla';
export const HSL = 'hsl';

export const DEFAULT_ANGLE_DOMAIN = [1];
export const MIN_NO_OF_TICKS = 2;
export const DEFAULT_NO_OF_TICKS = 10;

